import { Box, Stack, TypographyProps } from '@mui/material'
import { SxProps } from '@mui/system'
import { FC } from 'react'
import { EmphasizedNumber, GachaTicketThumbnail } from 'utoniq-ui'

export type DisplayProps = {
  ticket: number | string
  src: string
  variant?: TypographyProps['variant']
  sx?: SxProps
}

export const Display: FC<DisplayProps> = ({ ticket, src, variant, sx }) => {
  return (
    <Stack
      alignItems="center"
      justifyContent="center"
      direction="row"
      sx={{
        borderRadius: 3,
        height: 40,
        minWidth: 76,
      }}
    >
      <Box sx={{ mr: 2, mt: 4 }}>
        <GachaTicketThumbnail src={src} />
      </Box>
      <EmphasizedNumber variant={variant || 'h4'}>{ticket}</EmphasizedNumber>
    </Stack>
  )
}
